/**
 * legalDocumentsApi (1.34.0)
 *
 * Доступ к таблице public.legal_documents.
 *
 * Чтение публичное (RLS позволяет anon), поэтому страницы /legal/*
 * работают без авторизации.
 */

import { isSupabaseConfigured, requireSupabase } from '../auth/supabaseClient';

export type LegalDocumentKind = 'privacy' | 'consent' | 'terms';

export interface LegalDocument {
  id: string;
  kind: LegalDocumentKind;
  version: number;
  title: string;
  body_md: string;
  is_current: boolean;
  published_at: string;
}

/**
 * Загружает текущую (is_current=true) версию документа указанного kind.
 * Возвращает null если документа нет (например, миграция не применена).
 */
export async function fetchCurrentLegalDocument(
  kind: LegalDocumentKind,
): Promise<LegalDocument | null> {
  if (!isSupabaseConfigured) return null;
  const supabase = requireSupabase();

  const { data, error } = await supabase
    .from('legal_documents')
    .select('*')
    .eq('kind', kind)
    .eq('is_current', true)
    .maybeSingle();

  if (error) throw new Error(`fetchCurrentLegalDocument(${kind}): ${error.message}`);
  return (data as LegalDocument) ?? null;
}

/**
 * Загружает все текущие документы одним запросом.
 * Используется в LegalConsentGate чтобы проверить, на какие документы
 * нужно получить согласие.
 */
export async function fetchAllCurrentLegalDocuments(): Promise<LegalDocument[]> {
  if (!isSupabaseConfigured) return [];
  const supabase = requireSupabase();

  const { data, error } = await supabase
    .from('legal_documents')
    .select('*')
    .eq('is_current', true);

  if (error) throw new Error(`fetchAllCurrentLegalDocuments: ${error.message}`);
  return (data ?? []) as LegalDocument[];
}
